/**
 * Sandbox xz → domain xy for one live cast. Sets caster.liveWorldScale.
 */

import { SUMMONER_WORLD_SCALE } from './summonerSpellCaster.js';

export const LIVE_WORLD_SCALE = SUMMONER_WORLD_SCALE;

export function sandboxPlaneY(entity, fallback = 0) {
  if (entity && Number.isFinite(entity.z)) return entity.z;
  if (entity && Number.isFinite(entity.y)) return entity.y;
  return fallback;
}

export function resolveLiveWorldPos(player, cursor, ground) {
  const px = Number.isFinite(player?.x) ? player.x : 0;
  if (cursor && Number.isFinite(cursor.x) && Number.isFinite(cursor.z)) {
    return { x: cursor.x, y: cursor.z };
  }
  if (cursor && Number.isFinite(cursor.x) && Number.isFinite(cursor.y)) {
    return { x: cursor.x, y: cursor.y };
  }
  return { x: px, y: ground };
}

function stashEntityPlaneY(entities, player) {
  const savedYs = [];
  for (const e of entities || []) {
    if (!e || e === player) continue;
    savedYs.push({ e, y: e.y });
    if (Number.isFinite(e.z)) e.y = e.z;
  }
  return savedYs;
}

export function dispatchOnLivePlane(player, opts, dispatchFn) {
  const heightY = player.y;
  const ground = sandboxPlaneY(player);
  const savedYs = stashEntityPlaneY(opts.entities, player);
  player.y = ground;
  player.liveWorldScale = LIVE_WORLD_SCALE;
  try {
    return dispatchFn(resolveLiveWorldPos(player, opts.cursor, ground));
  } finally {
    delete player.liveWorldScale;
    player.z = player.y;
    player.y = heightY;
    for (const { e, y } of savedYs) e.y = y;
  }
}
